export default __webpack_public_path__ + "static/media/coin-vertical.f5981607.png";